// @flow
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
import classNames from 'classnames';
import Dropdown from 'components/atoms/dropdown';
import DotSeparator from 'components/atoms/dotSeparator';
import dropdownArrow from 'assets/images/arrow-pink.png';
import ButtonIncrementDecrement from 'components/atoms/buttonIncrementDecrement';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: {
    ticket_type: string,
    ticket_type_id: string,
    available_tickets: number,
    price: number,
  },
  type: string,
};
const TicketSelectionBox = (props: Props) => {
  const {
    data,
    type,
    className,
    standingTickets = 0,
    selectedTableDetails,
    manageStandingTicketCount,
    onDropDownClick,
    availability = 0,
  } = props;
  const { tableStrength = 0 } = selectedTableDetails;
  const containerClasses = classNames('ticket-selection-container', className);
  const { isMobile } = useViewport();

  const table_strength = [
    { value: 2, label: '2 GUESTS' },
    { value: 3, label: '3 GUESTS' },
    { value: 4, label: '4 GUESTS' },
    { value: 5, label: '5 GUESTS' },
    { value: 6, label: '6 GUESTS' },
    { value: 7, label: '7 GUESTS' },
    { value: 8, label: '8 GUESTS' },
  ];

  const checkTicketCount = () => {
    if (standingTickets === 0) return 'initial-value';
  };

  const ticketCountClass = classNames('ticket-count', checkTicketCount());

  const standingButtonCount = (
    <div className={'ticket-count-button-container'}>
      <ButtonIncrementDecrement
        type={'decrement'}
        initialValue={standingTickets}
        FinalValue={value => manageStandingTicketCount(value)}
        availableTickets={data.available_tickets}
        className={'decrement'}
      />
      <h3 className={ticketCountClass}>{standingTickets}</h3>
      <ButtonIncrementDecrement
        type={'increment'}
        initialValue={standingTickets}
        FinalValue={value => manageStandingTicketCount(value)}
        availableTickets={data.available_tickets}
        className={'increment'}
      />
    </div>
  );

  const sittingDropdownCount = (
    <div className={'sitting-dropdown-container'}>
      <Dropdown
        options={table_strength}
        value={tableStrength}
        onChange={e => {
          onDropDownClick(e.value);
        }}
        placeholder={isMobile ? 'Guests' : 'Select Number of Guests'}
        name={'Sitting Dropdown'}
      />
      <img src={dropdownArrow} alt={'drop-down'} />
    </div>
  );

  return (
    <div className={containerClasses}>
      <div className={'ticket-info-container'}>
        <div className={'ticket-type-name-container'}>
          <h3 className={'ticket-type-name'}>{data.ticket_type} Tickets</h3>
          <h4>{`${availability} Available`}</h4>
        </div>
        <DotSeparator />
        <div className={'item-price-container'}>
          {data.price > 499 ? (<h4 className={'price-value'}>INR {data.price} + GST</h4>) :
            <h4 className={'price-value'}>INR {data.price}</h4>
          }
        </div>
        {type === 'standing' && standingButtonCount}
        {type === 'sitting' && sittingDropdownCount}
      </div>
      {type === 'sitting' && <div className={'divider'} />}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    standingTickets: EventSelector.getStandingTickets(state),
    selectedTableDetails: EventSelector.getTableSelected(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { manageStandingTicketCount } = EventActions;
  return bindActionCreators(
    {
      manageStandingTicketCount,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketSelectionBox);
